import React from "react";
import WhiteLablelLogin from "./WhiteLablelLogin";
import { ReactComponent as LandingPage } from "../../assets/LandingPage.svg";
import { useLocation } from "react-router-dom";
import "./WhitelabelWelcome.css";  

const WhitelabelWelcome = ({ data }) => {
  const location = useLocation();

  return (
    <div className="welcome-container">
      <div className="welcome-content">
  
        <div className="welcome-left">
          <div className="welcome-illustration">
            <LandingPage />
            <div className="welcome-text">
              <p className="welcome-title">Fast, Efficient and Productive</p>
              <p className="welcome-subtitle">
                In this kind of post, the blogger introduces a person they’ve
                interviewed and provides some background information about the
                interviewee and their work. Following this is a transcript of
                the interview.
              </p>
            </div>
          </div>
        </div>

 
        <div className="welcome-right">
          <div className="welcome-card">
            {location.pathname === "/login" && <WhiteLablelLogin data={data} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhitelabelWelcome;
